import React, {
  useEffect,
  useState,
  useRef,
  lazy,
  Suspense,
} from "react";
import { Col, Row } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getEquipmentCategoriesList,
  getOrganizationList,
  logout,
  welnetLogin,
  welnetToken,
  logoutApi,
} from "@/services";

import {
  getQueryParams,
  isSuperAdmin,
  isDistributor,
  changeDataKeys,
  isServiceTechnician,
  isReviewer,
  isAuthor,
  isServiceTechnicianRole,
  isCurriculumAdmin,
} from "@/helpers";
import _ from "lodash";
import Select from "react-select";
import { BiSearch } from "react-icons/bi";
import { clearDashboardReducer } from "@/reducers/dashboard";
import { changeWebApp } from "@/reducers/auth";

import LogoContainer from "./LogoContainer";
import "./../../../theme/Colors.css";
import "../topbar.css";
import {
  isEditCurriculumComponents,
  selectedVersion,
} from "@/reducers/curriculum";
import CurriculumSearch from "@/pages/curriculum/searchModal";
import { toast } from "react-toastify";
import { getCurriculumList } from "@/services/curriculum.service";
import curriculumTitleIcon from "../../../assets/images/curriculumTitleIcon.png";
const Notification = lazy(() => import("../../Notification"));
const ProfileMenu = lazy(() => import("./ProfileMenu"));

const Topbar = (props) => {
  const dispatch = useDispatch();
  const reducerData = useSelector((state) => {
    return {
      profile: state.auth && state.auth.user,
      isLoggedIn: state.auth && state.auth.isLoggedIn,
      organizationList: state.auth && state.auth.organizationList,
      webApp: state.auth.webApp,
      versions: state.curriculum.versions,
      selectedVersions: state.curriculum.selectedVersion,
      isEditValue: state.curriculum.isEditCurriculumComponents,
      searchedCurriculumItemData: state.curriculum.searchedCurriculumItem,
      parentCategories: state.equipment.parentCategories,
      curriculumListData: state.curriculum.curriculumListData,
    };
  });
  const {
    isLoggedIn,
    profile,
    organizationList,
    webApp,
    versions,
    selectedVersions,
    searchedCurriculumItemData,
    parentCategories,
    isEditValue,
    curriculumListData,
  } = reducerData;
  const location = useLocation();
  const checkOrgPresent = organizationList?.find(
    (findItem) => +findItem?.id === +profile?.account?.id,
  );
  const user_account_data = [
    ...(Array.isArray(organizationList) ? organizationList : []),
    ...(checkOrgPresent ? [] : profile?.account ? [profile.account] : []),
  ];
  const getIsEditItemData = localStorage.getItem("isEdit");
  const [state, setState] = useState({
    width: 0,
    height: 0,
    search: null,
    organizationState: true,
    isEdit: "",
    organizationData: [],
  });
  const pathname = location.pathname;
  const isCurriculum = pathname.includes("curriculum");
  const isDashboard = pathname.includes("dashboard");
  const token = JSON.parse(localStorage.getItem("token"));
  const mappedFilteredData = curriculumListData?.map((item) => item?.id);
  const isTechnician = isServiceTechnician();
  const orgListRequested = useRef(false);

  useEffect(() => {
    if (isCurriculum) {
      dispatch(getCurriculumList());
    }
  }, [isCurriculum, dispatch]);

  useEffect(() => {
    if (parentCategories?.length) {
      localStorage.setItem("permissions", JSON.stringify(parentCategories));
      if (mappedFilteredData?.length) {
        localStorage.setItem("curriculumItemsId", mappedFilteredData);
      }
    }
  }, [parentCategories, mappedFilteredData]);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (organizationList?.length) {
      setState((prev) => ({ ...prev, organizationData: user_account_data }));
    }
  }, [organizationList]);
  /* eslint-disable react-hooks/exhaustive-deps */

  const showSelectBox =
  isSuperAdmin() ||
  isDistributor() ||
  (isServiceTechnician() && isServiceTechnicianRole());

  const { isSearch, toggleSideNav } = props;
  const { search, organizationState, isEdit } = state;
  const navigate = useNavigate();
  const windowUrl = location.search;
  const params = new URLSearchParams(windowUrl);
  const inputRef = useRef(null);
  let switchBtnColor = isEditValue ? "Bg-success" : "Bg-danger";

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const versionId = params.get("versionId");

  if (versionId && versions?.length) {
    const matched = versions.find(
      (v) => +v.id === +versionId
    );

    if (matched && matched.id !== selectedVersions?.id) {
      dispatch(selectedVersion(matched));
    }
  }
}, [location.search, versions]);

  useEffect(() => {
    if (getIsEditItemData === "true") {
      setState((prev) => ({ ...prev, isEdit: true }));
      dispatch(isEditCurriculumComponents(true));
    }
  }, [isEdit, getIsEditItemData, dispatch]);

  const sizes = {
    searchBox:
      isSuperAdmin() ||
      isDistributor() ||
      isServiceTechnician() ||
      isCurriculum
        ? { xs: 2, sm: 3, md: 3, lg: 3, xl: 3, xxl: { offset: 1, span: 3 } }
        : { xs: 5, sm: 4, md: 4, lg: 2, xl: 4, xxl: 4 },
    orgBox:
      isSuperAdmin() ||
      isDistributor() ||
      isServiceTechnician() ||
      isCurriculum
        ? {
            xs: { span: 12 },
            sm: 2,
            md: 2,
            lg: 2,
            xl: 1,
            xxl: { offset: 1, span: 2 },
          }
        : {},
    profileBox:
      isSuperAdmin() ||
      isDistributor() ||
      isServiceTechnician() ||
      isCurriculum
        ? { xs: 3, sm: { span: 1, order: "last" }, md: 2, lg: 2, xl: 2, xxl: 2 }
        : { xs: 2, sm: 1, md: 3, lg: 2, xl: 2, xxl: 2 },
  };

  const orgSelectStyles = {
    option: (pre, state) => ({
      ...pre,
      backgroundColor: state.isSelected
        ? "var(--blue-color-light)"
        : state.isFocused
          ? "#e9ecef"
          : "",
      color: state.isSelected
        ? "var(--primary-color)"
        : state.isFocused
          ? "#545454"
          : "#232323",
      padding: "8px 0 8px 20px",
      cursor: "pointer",
    }),
    control: () => ({ display: "flex", width: "100%" }),
    groupHeading: (pre) => ({ ...pre, color: "#818188", fontSize: "12px" }),
    singleValue: (pre) => ({ ...pre, color: "var(--primary-color)" }),
  };

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      window.history.pushState(null, null, window.location.href);
      const handlePopState = () => {
        window.history.go(1);
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!window.location.href?.includes("curriculum")) {
      dispatch(changeWebApp("schoolhealth"));
      // localStorage.setItem("isCurriculum", "schoolhealth");
    }
    if (token && pathname?.includes("/curriculum")) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      Object.assign(link, {
        type: "image/x-icon",
        rel: "shortcut icon",
        href: curriculumTitleIcon,
      });
      document.head.appendChild(link);
    }
  }, [pathname, token, dispatch]);

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    const orgListLoaded = Array.isArray(organizationList);
    if (isCurriculum || orgListRequested.current || orgListLoaded) {
      return;
    }
    if (!showSelectBox) {
      return;
    }

    orgListRequested.current = true;
    dispatch(getOrganizationList())
      .unwrap()
      .then((res) => {
        if (res?.success) {
          setState((prev) => ({ ...prev, organizationData: res?.data }));
        }
      })
      .catch(() => {
        orgListRequested.current = false;
      });
    // if(isSuperAdmin()){
    //   dispatch(getDistributorList())
    // }
  }, [dispatch, isCurriculum, organizationList, isTechnician]);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    dispatch(logoutApi());
    const newWebApp = webApp === "schoolhealth" ? "curriculum" : "schoolhealth";
    dispatch(changeWebApp(newWebApp));
    setTimeout(() => {
      window.location.reload();
    }, 0);
    navigate("/", { replace: true });
  };

  const formatGroupLabel = (data) => (
    <div className="center justify-content-start">
      <span title={data?.label} className="text-truncate">
        {data.label}
      </span>
    </div>
  );

 useEffect(() => {
  if (isDashboard) return;

  let token = JSON.parse(localStorage.getItem("token"));
  if (token?.account?.id && organizationState) {
    setState((prev) => ({
      ...prev,
      organizationState: false,
    }));
    dispatch(getEquipmentCategoriesList());
  }
}, [dispatch, organizationState, isDashboard]);

  useEffect(() => {
    if (searchedCurriculumItemData?.type === "version") {
      const searchedVersion = _.find(versions, function (item) {
        return item.name === searchedCurriculumItemData?.name;
      });
      dispatch(selectedVersion(searchedVersion));
    }
  }, [searchedCurriculumItemData, versions, dispatch]);

  const getAccountsList = (list) => {
    if (!Array.isArray(list) || list.length === 0) return [];
    const labels = new Set();
    return list.reduce((acc, item) => {
      const distributorId = item?.distributor_id;

      if (!labels.has(distributorId)) {
        labels.add(distributorId);
        acc.push({
          label: item?.distributor?.name || item?.name,
          options: changeDataKeys(
            list.filter((i) => i?.distributor_id === distributorId),
            { name: "label", id: "value" },
          ),
        });
      }
      return acc;
    }, []);
  };

  const getAccountName = () => {
    let data = JSON.parse(localStorage.getItem("token"));
    let item;
    if (data?.account?.name) item = data?.account;
    else item = organizationList && organizationList[0];
    if (item) item = { ...item, label: item?.name };
    if (item) item.label = item?.name ?? "";
    return item || null;
  };

  const changeWeb = async (appName) => {
    switch (appName) {
      case "schoolhealth":
        dispatch(changeWebApp(appName));
        // localStorage.setItem("isCurriculum", "schoolhealth");
        navigate("/dashboard");
        break;
      case "welnet":
        const emailObj = {
          email: profile?.email,
          // email: 'ted.brace@gmail.com',
        };
        try {
          const getToken = await dispatch(
            welnetToken({ data: emailObj }),
          ).unwrap();
          if (getToken?.access_token) {
            const welnetToken = {
              accessToken: getToken?.access_token,
            };

            try {
              const getWelnetUrl = await dispatch(
                welnetLogin({ data: welnetToken }),
              ).unwrap();

              if (getWelnetUrl?.data?.redirect_uri) {
                window.open(getWelnetUrl?.data?.redirect_uri, "_blank");
              } else {
                toast.error(getWelnetUrl?.data?.message);
              }
            } catch (error) {}
          }
        } catch (error) {}
        break;
      case "curriculum":
        navigate("/curriculum");
        dispatch(changeWebApp(appName));
        // localStorage.setItem("isCurriculum", "curriculum");
        break;
      default:
        dispatch(changeWebApp(appName));
        // localStorage.setItem("isCurriculum", "schoolhealth");
        navigate("/dashboard");
        break;
    }
  };

  const updateWindowDimensions = () =>
    setState((prev) => ({
     ...prev,
     width: window.innerWidth,
     height: window.innerHeight,
   }));

  const getValue = () => {
    if (location.search.includes("search")) return params.get("search");
    else return "";
  };

  const getOptionsData = () => {
    if (isCurriculum) {
      return changeDataKeys(versions, { name: "label", id: "value" });
    }
    return getAccountsList(user_account_data);
  };

  const handleAccountSelection = (account) => {
    let acc = { ...account, id: account.value || "1", name: account.label };
    let token = JSON.parse(localStorage.getItem("token"));
    token.account = acc;
    localStorage.setItem("token", JSON.stringify(token));
    clearDashboardReducer();
    navigate("/");
    window.location.reload();
  };

  const getParams = () => {
    let objectParams = { search: search };
    if (location?.search) {
      objectParams = JSON.parse(
        '{"' +
          decodeURI(location?.search.substring(1))
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}',
      );
      objectParams.search = search;
    }
    return "?" + getQueryParams(objectParams);
  };

  const setVersion = (e) => {
    dispatch(selectedVersion(e));
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set("versionId", e.value || e.id);
    currentURL.searchParams.delete("grade-level");
    window.history.pushState({}, "", currentURL);
  };

  const handleEditCurriculum = (e) => {
    setState((prev)=>({...prev, isEdit: !isEditValue }));
    dispatch(isEditCurriculumComponents(!isEditValue));
    localStorage.setItem("isEdit", JSON.stringify(!isEditValue));
  };

  const getVersionName = () => {
    return selectedVersions?.label
      ? { label: selectedVersions?.label, value: selectedVersions?.value }
      : { label: selectedVersions?.name, value: selectedVersions?.id };
  };

  return (
    <>
      <Row className="d-flex flex-row justify-content-between topBar pe-3 Bg-fff m-0">
        <Col xs={4} sm={4} md={2} lg={2} xl={2} xxl={2} className="h-100">
          <LogoContainer
            changeWeb={changeWeb}
            toggleSideNav={toggleSideNav}
            isSearch={isSearch}
            webApp={webApp}
          />
        </Col>
        {pathname.includes("/curriculum/") &&
        ![
          "/curriculum",
          "/curriculum/profile",
          "/curriculum/setting",
          "/curriculum/profile/edit",
        ]?.includes(pathname) &&
        versions?.length &&
        (isSuperAdmin() || isReviewer() || isAuthor() || isCurriculumAdmin()) ? (
          <Col
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
            className="mt-2 d-flex align-items-center justify-content-center"
          >
            <input
              className="switch-checkbox"
              id={`switch`}
              checked={isEditValue}
              type="checkbox"
            />
            <button
              onClick={() => handleEditCurriculum()}
              className={`switch-label`}
              htmlFor={`switch`}
            >
              <span className={`switch-button ${switchBtnColor}`} />
            </button>
            <span className="C-818188 ps-2" style={{ minWidth: "70px" }}>
              {isEditValue ? ` Edit On ` : "Edit Off"}
            </span>
          </Col>
        ) : (
          ""
        )}

        {!isCurriculum ? (
          <Col
            {...sizes.searchBox}
            className={`d-flex align-items-center justify-content-start justify-content-lg-center h-100 me-md-0 ${
              isSuperAdmin() || isServiceTechnician() ? "me-5" : "ms-1"
            } `}
          >
            <div
              className="rounded ps-2 ms-md-0 center justify-content-start justify-content-md-start"
              style={{ height: "43px", width: "100%" }}
            >
              <div
                className="h-100 center ps-2"
                style={{
                  color: "#cdcdcd",
                  background: "#f5f5f5",
                  borderRadius: "6px 0px 0px 6px",
                }}
              >
                <BiSearch
                  id="header.compliance.button.search"
                  size={25}
                  onClick={() => inputRef.current.focus()}
                />
              </div>
              <input
                id="header.compliance.input.search"
                type="text"
                placeholder="Search"
                ref={inputRef}
                value={search !== null ? search : getValue()}
                className="border-0 m-0 p-0 ps-2 h-100 searchInput"
                style={{ fontSize: "20px" }}
                onChange={(e) => setState((prev)=>({...prev, search: e.target.value }))}
                onKeyUp={(event) => {
                  if (event.keyCode === 13 && search) {
                    setState((prev)=>({...prev, search: null }));
                    navigate({ pathname: "/search", search: getParams() });
                  }
                }}
              />
            </div>
          </Col>
        ) : (
          <div
            className={`col-1 ${
              pathname.includes("/curriculum/") &&
              ![
                "/curriculum",
                "/curriculum/profile",
                "/curriculum/setting",
                "/curriculum/profile/edit",
              ]?.includes(pathname) &&
              versions?.length
                ? "col-md-3"
                : "col-md-4"
            }`}
          >
            <Suspense>
              <CurriculumSearch />
            </Suspense>
          </div>
        )}
        <Col
          {...sizes?.profileBox}
          className="d-flex align-items-center justify-content-end h-100 p-md-0"
        >
          <Suspense>
            <div className="me-2 me-md-0">
              {isCurriculum ? "" : <Notification />}
            </div>
            <div>
              <ProfileMenu
                isLoggedIn={isLoggedIn}
                profile={profile}
                handleLogout={handleLogout}
              />
            </div>
          </Suspense>
        </Col>
        {!isCurriculum && showSelectBox ? (
          <Col
            {...sizes?.orgBox}
            className="center h-100 p-sm-0 p-3 Bg-fff"
            id="orgDropdown"
          >
            <Select
              className="d-flex w-100 F-14 rounded border C-primary bg-fff"
              styles={orgSelectStyles}
              value={getAccountName()}
              onChange={(e) => handleAccountSelection(e)}
              options={getOptionsData()}
              formatGroupLabel={formatGroupLabel}
              id="header.compliance.textInput.searchOrg"
              inputId="header.compliance.textInput.searchOrg"
            />
          </Col>
        ) : null}
        {pathname.includes("/curriculum/") &&
        ![
          "/curriculum",
          "/curriculum/profile",
          "/curriculum/setting",
          "/curriculum/profile/edit",
        ]?.includes(pathname) &&
        versions?.length ? (
          <Col
            {...sizes?.orgBox}
            className="center h-100 bg-white ms-md-0 p-sm-0 p-3"
            id="orgDropdown"
          >
            <Select
              className="d-flex w-100 F-14 rounded border C-curriculum bg-fff"
              styles={orgSelectStyles}
              value={getVersionName()}
              onChange={(e) => setVersion(e)}
              options={getOptionsData()}
              formatGroupLabel={formatGroupLabel}
              placeholder={"select version"}
            />
          </Col>
        ) : null}
      </Row>
      <Outlet />
    </>
  );
};

export default Topbar;
